(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-bundle-has-swag"]) return;
  try {
    
    simply.closeMenu = function() {
        $("#bundle-close").click(function(){
          $("#quick_add_result_wrapper").css("display", "none");
        });
    }
  simply.clickEvent = function(){

    $(".qty").click(function(){
      var counter = $(this).attr("data-counter");

      var value = $(this).val();
      var max = $(this).attr("max");

      value = parseInt(value);
      max = parseInt(max);

      if (counter == 'riched'){
        value = value + 1;
      }
      if(value > max){
        var target = $(this).siblings(".qty_error");
        $("span",target).html(max);
        target.fadeIn();
        setTimeout(function(){ target.fadeOut(); }, 3000);
      }
      if(value == max){
        $(this).attr("data-counter","riched");
      }
    });

  };
  simply.hoverEvent = function(){
    
  };
  simply.changeEvent = function(){
    $(".qty").change(function(){
      var parent = $(this).closest(".product_details");
      var value = $(this).val();
      if(value == 0){
        $(".product_check",parent).prop('checked', false);
      }
      else{
        $(".product_check",parent).prop('checked', true);
      }


      var counter = $(this).attr("data-counter");

      var value = $(this).val();
      var max = $(this).attr("max");

      value = parseInt(value);
      max = parseInt(max);

      if (counter == 'riched'){
        value = value + 1;
      }
      if(value > max){
        var target = $(this).siblings(".qty_error");
        $("span",target).html(max);
        target.fadeIn();
        setTimeout(function(){ target.fadeOut(); }, 3000);
      }
      if(value == max){
        $(this).attr("data-counter","riched");
      }
    });
    $(".product_check").change(function(){
      var parent = $(this).closest(".product_details");
      if ($(this).is(':checked')) {
        $(".qty",parent).val(1);
      }
      else{
        $(".qty",parent).val(0);
      }
    });
    $("#bundle_collection .option_selector.options").change(function(){
      var option =  $('option:selected', this);
      var img = option.attr("data-img");
      if(!cn(img)){
        var image = new Image();
        var parent = $(this).closest(".product_details");
        $(".loading",parent).show();
        $(".image_block",parent).addClass("active");
        image.onload = function(){
          $(".image_block",parent).removeClass("active");
          $(".image_block img",parent).attr("src",img);
          $(".loading",parent).hide();
        };
        image.src = img;  

      }
      simply.getValues(option);
    });
  };
  simply.submitEvent = function(){
    $("#bundle_collection .bundle_form").submit(function(e){
      e.preventDefault();
      //$.fancybox("<p class='wait'>Please wait...</p>");as
      $("#quick_add_result_wrapper").css("display", "flex");
      $("#quick_add_result").css("display", "none");
      $("#collection-bundle-error").css("display", "none");
      $("#collection-bundle-loader").css("display", "flex");
      
      console.log("data loading...");
      var form = $(this);
      var products = [];
      $(".product_check:checked",form).each(function(index,item){
        var parent = $(item).closest(".product_details");
        var obj = {};
        obj.id = $(".option_selector",parent).val();
        obj.qty = $(".qty",parent).val();
        products.push(obj);
      });
      simply.ajaxCart(products);
    });
  };
  simply.getValues = function(option){
    if(cn(option)){
      $("#bundle_collection .product_details .option_selector").each(function(){
        var option;
        if($(this).hasClass("options")){
          option = $('option:selected', this);
        }
        else{
          option = $(this);
        }
        simply.getValuesAction(option);
      });
    }
    else{
      simply.getValuesAction(option);
    }
  };
  simply.getValuesAction = function(option){
    var parent = option.closest(".product_details");
    var price = option.attr("data-price");
    var qty = option.attr("data-qty");
    if(qty == '0'){
      $(".price",parent).text("Sold Out");
      $(".qty",parent).prop("disabled",true).val(0);
      $(".product_check",parent).prop('checked', false).prop("disabled",true);
    }
    else{
      $(".price",parent).text(price);
      $(".qty",parent).prop("disabled",false).val(1);
      $(".qty",parent).attr("max",qty);
      $(".product_check",parent).prop('checked', true).prop("disabled",false);
    }
  };
  simply.ajaxCart =  function(products){
    if(products.length > 0){
      var product = products.pop();
      var qty = product.qty;
      var id = product.id;
      if(cn(qty)){
        qty = 1;
      }
      var params = {
        type: 'POST',
        url: '/cart/add.js',
        data: 'quantity=' + parseInt(qty) + '&id=' + id,
        dataType: 'json',
        success: function(line_item) {
          simply.ajaxCart(products);
        },
        error: function(XMLHttpRequest, textStatus) {
          var error=  JSON.parse((XMLHttpRequest.responseText)).description;
          var data = ("<h6 class='fancy_error'>"+error+"</h6>");
          console.log("data",data);
          $("#collection-bundle-error").css("display", "block");
          $("#collection-bundle-error").append(`<h6>${error}</h6>`);
          //$.fancybox(data);
          $("#collection-bundle-loader").css("display", "none");

          // Hide popup after 3seconds
          setTimeout(function(){
            $("#quick_add_result_wrapper").css("display", "none");
            $("#collection-bundle-error").empty();
            error = '';
          }, 3000);
        }
      };
      jQuery.ajax(params);
    }
    else{ 
      setTimeout(function(){
        var data= $("#quick_add_result_wrapper").html();
        $("#quick_add_result_wrapper").css("display", "flex");
        $("#quick_add_result").css("display", "block");
        $("#collection-bundle-loader").css("display", "none");
        //$("#quick_add_result_wrapper").append(data);
        console.log("data",data);
        // $.fancybox(data);
      }, 2000);
      
    }
  };
  
  simply.init = function(){
    simply.clickEvent();
    simply.hoverEvent();
    simply.changeEvent();
    simply.submitEvent();
    simply.closeMenu();
    if($("#bundle_collection").length > 0){
       //simply.getValues();
    }
  };
  $(document).ready(function(){
    simply.init();

    // if (window.jQuery) {  
    //     // jQuery is loaded  
    //     alert("Yeah!");
    // } else {
    //     // jQuery is not loaded
    //     alert("Doesn't Work");
    // }
  });

    
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-bundle-no-swag"]) return;
  try {
    
    simply.closeMenu = function() {
        $("#bundle-close").click(function(){
          $("#quick_add_result_wrapper").css("display", "none");
        });
    }
  simply.clickEvent = function(){

    $(".qty").click(function(){
      var counter = $(this).attr("data-counter");

      var value = $(this).val();
      var max = $(this).attr("max");

      value = parseInt(value);
      max = parseInt(max);

      if (counter == 'riched'){
        value = value + 1;
      }
      if(value > max){
        var target = $(this).siblings(".qty_error");
        $("span",target).html(max);
        target.fadeIn();
        setTimeout(function(){ target.fadeOut(); }, 3000);
      }
      if(value == max){
        $(this).attr("data-counter","riched");
      }
    });

  };
  simply.hoverEvent = function(){
    
  };
  simply.changeEvent = function(){
    $(".qty").change(function(){
      var parent = $(this).closest(".product_details");
      var value = $(this).val();
      if(value == 0){
        $(".product_check",parent).prop('checked', false);
      }
      else{
        $(".product_check",parent).prop('checked', true);
      }


      var counter = $(this).attr("data-counter");

      var value = $(this).val();
      var max = $(this).attr("max");

      value = parseInt(value);
      max = parseInt(max);

      if (counter == 'riched'){
        value = value + 1;
      }
      if(value > max){
        var target = $(this).siblings(".qty_error");
        $("span",target).html(max);
        target.fadeIn();
        setTimeout(function(){ target.fadeOut(); }, 3000);
      }
      if(value == max){
        $(this).attr("data-counter","riched");
      }
    });
    $(".product_check").change(function(){
      var parent = $(this).closest(".product_details");
      if ($(this).is(':checked')) {
        $(".qty",parent).val(1);
      }
      else{
        $(".qty",parent).val(0);
      }
    });
    $("#bundle_collection .option_selector.options").change(function(){
      var option =  $('option:selected', this);
      var img = option.attr("data-img");
      if(!cn(img)){
        var image = new Image();
        var parent = $(this).closest(".product_details");
        $(".loading",parent).show();
        $(".image_block",parent).addClass("active");
        image.onload = function(){
          $(".image_block",parent).removeClass("active");
          $(".image_block img",parent).attr("src",img);
          $(".loading",parent).hide();
        };
        image.src = img;  

      }
      simply.getValues(option);
    });
  };
  simply.submitEvent = function(){
    $("#bundle_collection .bundle_form").submit(function(e){
      e.preventDefault();
      //$.fancybox("<p class='wait'>Please wait...</p>");as
      $("#quick_add_result_wrapper").css("display", "flex");
      $("#quick_add_result").css("display", "none");
      $("#collection-bundle-error").css("display", "none");
      $("#collection-bundle-loader").css("display", "flex");
      
      console.log("data loading...");
      var form = $(this);
      var products = [];
      $(".product_check:checked",form).each(function(index,item){
        var parent = $(item).closest(".product_details");
        var obj = {};
        obj.id = $(".option_selector",parent).val();
        obj.qty = $(".qty",parent).val();
        products.push(obj);
      });
      simply.ajaxCart(products);
    });
  };
  simply.getValues = function(option){
    if(cn(option)){
      $("#bundle_collection .product_details .option_selector").each(function(){
        var option;
        if($(this).hasClass("options")){
          option = $('option:selected', this);
        }
        else{
          option = $(this);
        }
        simply.getValuesAction(option);
      });
    }
    else{
      simply.getValuesAction(option);
    }
  };
  simply.getValuesAction = function(option){
    var parent = option.closest(".product_details");
    var price = option.attr("data-price");
    var qty = option.attr("data-qty");
    if(qty == '0'){
      $(".price",parent).text("Sold Out");
      $(".qty",parent).prop("disabled",true).val(0);
      $(".product_check",parent).prop('checked', false).prop("disabled",true);
    }
    else{
      $(".price",parent).text(price);
      $(".qty",parent).prop("disabled",false).val(1);
      $(".qty",parent).attr("max",qty);
      $(".product_check",parent).prop('checked', true).prop("disabled",false);
    }
  };
  simply.ajaxCart =  function(products){
    if(products.length > 0){
      var product = products.pop();
      var qty = product.qty;
      var id = product.id;
      if(cn(qty)){
        qty = 1;
      }
      var params = {
        type: 'POST',
        url: '/cart/add.js',
        data: 'quantity=' + parseInt(qty) + '&id=' + id,
        dataType: 'json',
        success: function(line_item) {
          simply.ajaxCart(products);
        },
        error: function(XMLHttpRequest, textStatus) {
          var error=  JSON.parse((XMLHttpRequest.responseText)).description;
          var data = ("<h6 class='fancy_error'>"+error+"</h6>");
          console.log("data",data);
          $("#collection-bundle-error").css("display", "block");
          $("#collection-bundle-error").append(`<h6>${error}</h6>`);
          //$.fancybox(data);
          $("#collection-bundle-loader").css("display", "none");

          // Hide popup after 3seconds
          setTimeout(function(){
            $("#quick_add_result_wrapper").css("display", "none");
            $("#collection-bundle-error").empty();
            error = '';
          }, 3000);
        }
      };
      jQuery.ajax(params);
    }
    else{ 
      setTimeout(function(){
        var data= $("#quick_add_result_wrapper").html();
        $("#quick_add_result_wrapper").css("display", "flex");
        $("#quick_add_result").css("display", "block");
        $("#collection-bundle-loader").css("display", "none");
        //$("#quick_add_result_wrapper").append(data);
        console.log("data",data);
        // $.fancybox(data);
      }, 2000);
      
    }
  };
  
  simply.init = function(){
    simply.clickEvent();
    simply.hoverEvent();
    simply.changeEvent();
    simply.submitEvent();
    simply.closeMenu();
    if($("#bundle_collection").length > 0){
       //simply.getValues();
    }
  };
  $(document).ready(function(){
    simply.init();

    // if (window.jQuery) {  
    //     // jQuery is loaded  
    //     alert("Yeah!");
    // } else {
    //     // jQuery is not loaded
    //     alert("Doesn't Work");
    // }
  });

    
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-bundle"]) return;
  try {
    
    simply.closeMenu = function() {
        $("#bundle-close").click(function(){
          $("#quick_add_result_wrapper").css("display", "none");
        });
    }
  simply.clickEvent = function(){

    $(".qty").click(function(){
      var counter = $(this).attr("data-counter");

      var value = $(this).val();
      var max = $(this).attr("max");

      value = parseInt(value);
      max = parseInt(max);

      if (counter == 'riched'){
        value = value + 1;
      }
      if(value > max){
        var target = $(this).siblings(".qty_error");
        $("span",target).html(max);
        target.fadeIn();
        setTimeout(function(){ target.fadeOut(); }, 3000);
      }
      if(value == max){
        $(this).attr("data-counter","riched");
      }
    });

  };
  simply.hoverEvent = function(){
    
  };
  simply.changeEvent = function(){
    $(".qty").change(function(){
      var parent = $(this).closest(".product_details");
      var value = $(this).val();
      if(value == 0){
        $(".product_check",parent).prop('checked', false);
      }
      else{
        $(".product_check",parent).prop('checked', true);
      }


      var counter = $(this).attr("data-counter");

      var value = $(this).val();
      var max = $(this).attr("max");

      value = parseInt(value);
      max = parseInt(max);

      if (counter == 'riched'){
        value = value + 1;
      }
      if(value > max){
        var target = $(this).siblings(".qty_error");
        $("span",target).html(max);
        target.fadeIn();
        setTimeout(function(){ target.fadeOut(); }, 3000);
      }
      if(value == max){
        $(this).attr("data-counter","riched");
      }
    });
    $(".product_check").change(function(){
      var parent = $(this).closest(".product_details");
      if ($(this).is(':checked')) {
        $(".qty",parent).val(1);
      }
      else{
        $(".qty",parent).val(0);
      }
    });
    $("#bundle_collection .option_selector.options").change(function(){
      var option =  $('option:selected', this);
      var img = option.attr("data-img");
      if(!cn(img)){
        var image = new Image();
        var parent = $(this).closest(".product_details");
        $(".loading",parent).show();
        $(".image_block",parent).addClass("active");
        image.onload = function(){
          $(".image_block",parent).removeClass("active");
          $(".image_block img",parent).attr("src",img);
          $(".loading",parent).hide();
        };
        image.src = img;  

      }
      simply.getValues(option);
    });
  };
  simply.submitEvent = function(){
    $("#bundle_collection .bundle_form").submit(function(e){
      e.preventDefault();
      //$.fancybox("<p class='wait'>Please wait...</p>");as
      $("#quick_add_result_wrapper").css("display", "flex");
      $("#quick_add_result").css("display", "none");
      $("#collection-bundle-error").css("display", "none");
      $("#collection-bundle-loader").css("display", "flex");
      
      console.log("data loading...");
      var form = $(this);
      var products = [];
      $(".product_check:checked",form).each(function(index,item){
        var parent = $(item).closest(".product_details");
        var obj = {};
        obj.id = $(".option_selector",parent).val();
        obj.qty = $(".qty",parent).val();
        products.push(obj);
      });
      simply.ajaxCart(products);
    });
  };
  simply.getValues = function(option){
    if(cn(option)){
      $("#bundle_collection .product_details .option_selector").each(function(){
        var option;
        if($(this).hasClass("options")){
          option = $('option:selected', this);
        }
        else{
          option = $(this);
        }
        simply.getValuesAction(option);
      });
    }
    else{
      simply.getValuesAction(option);
    }
  };
  simply.getValuesAction = function(option){
    var parent = option.closest(".product_details");
    var price = option.attr("data-price");
    var qty = option.attr("data-qty");
    if(qty == '0'){
      $(".price",parent).text("Sold Out");
      $(".qty",parent).prop("disabled",true).val(0);
      $(".product_check",parent).prop('checked', false).prop("disabled",true);
    }
    else{
      $(".price",parent).text(price);
      $(".qty",parent).prop("disabled",false).val(1);
      $(".qty",parent).attr("max",qty);
      $(".product_check",parent).prop('checked', true).prop("disabled",false);
    }
  };
  simply.ajaxCart =  function(products){
    if(products.length > 0){
      var product = products.pop();
      var qty = product.qty;
      var id = product.id;
      if(cn(qty)){
        qty = 1;
      }
      var params = {
        type: 'POST',
        url: '/cart/add.js',
        data: 'quantity=' + parseInt(qty) + '&id=' + id,
        dataType: 'json',
        success: function(line_item) {
          simply.ajaxCart(products);
        },
        error: function(XMLHttpRequest, textStatus) {
          var error=  JSON.parse((XMLHttpRequest.responseText)).description;
          var data = ("<h6 class='fancy_error'>"+error+"</h6>");
          console.log("data",data);
          $("#collection-bundle-error").css("display", "block");
          $("#collection-bundle-error").append(`<h6>${error}</h6>`);
          //$.fancybox(data);
          $("#collection-bundle-loader").css("display", "none");

          // Hide popup after 3seconds
          setTimeout(function(){
            $("#quick_add_result_wrapper").css("display", "none");
            $("#collection-bundle-error").empty();
            error = '';
          }, 3000);
        }
      };
      jQuery.ajax(params);
    }
    else{ 
      setTimeout(function(){
        var data= $("#quick_add_result_wrapper").html();
        $("#quick_add_result_wrapper").css("display", "flex");
        $("#quick_add_result").css("display", "block");
        $("#collection-bundle-loader").css("display", "none");
        //$("#quick_add_result_wrapper").append(data);
        console.log("data",data);
        // $.fancybox(data);
      }, 2000);
      
    }
  };
  
  simply.init = function(){
    simply.clickEvent();
    simply.hoverEvent();
    simply.changeEvent();
    simply.submitEvent();
    simply.closeMenu();
    if($("#bundle_collection").length > 0){
       //simply.getValues();
    }
  };
  $(document).ready(function(){
    simply.init();

    // if (window.jQuery) {  
    //     // jQuery is loaded  
    //     alert("Yeah!");
    // } else {
    //     // jQuery is not loaded
    //     alert("Doesn't Work");
    // }
  });

    
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;
      theme.ProductBlockManager.loadImages(productRecommendationsSection);
      theme.initAnimateOnScroll();
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
